import React, {createContext, useState} from 'react';
import {Toast} from "../components/common/Toast";
import {getErrorMessage} from "../helpers/Utils";
import TokenConfigService from "../services/TokenConfigService";

export const TokenConfigContext = createContext("TokenConfigContext");

const TokenConfigContextProvider = ({children}) => {

    const [tokenConfigList, setTokenConfigList] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [loadingTokenConfigList, setLoadingTokenConfigList] = useState(false);

    const getTokenConfigList = async (id, params) => {
        try {
            setLoadingTokenConfigList(true);
            const response = await TokenConfigService.getTokenConfigList(id, params);
            setTokenConfigList(response.data.content);
            setTotalElements(response.data.totalElements);
            setLoadingTokenConfigList(false);
        } catch (error) {
            setLoadingTokenConfigList(false);
            const message = getErrorMessage(error);
            Toast("error", "Error", message);
        }

    }

    return (
        <TokenConfigContext.Provider
            value={{
                getTokenConfigList,
                tokenConfigList,
                totalElements,
                loadingTokenConfigList,
            }}
        >
            {children}
        </TokenConfigContext.Provider>
    );
}

export default TokenConfigContextProvider;
